import React from 'react'
import { css } from '@emotion/core'
import { RotateLoader } from 'react-spinners'
import Menu from '../containers/menu'
import Slider from '../containers/slider'
import About from '../containers/about'
import Skills from '../containers/skills'
import MyInterest from '../containers/interest'
import Service from '../containers/service'
import TimeLine from '../containers/timeline'
import Projects from '../containers/projects'
import Footer from '../containers/footer'
import ScrollTop from '../containers/scroll'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../assets/css/color1.css'
import '../assets/css/theme.css'

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    top: 400px;
`;

function Resume() {
    const loading = React.useState(true)
    const [loader,setLoader] = React.useState(false)
    React.useEffect (() => {
        const interval = setInterval(() => {
            setLoader(true)
        }, 3000);
        return () => clearInterval(interval);
    },[])

    return (
        loader ? 
            <React.Fragment>
                <div className="main-menu-wrapper">
                    
                    <Menu />
                    <div id="content">
                        <Slider />
                        <About />
                        <Skills />
                        <MyInterest />
                        <Service />
                        <TimeLine />
                        <Projects />
                        <Footer />
                        <ScrollTop />
                    </div>
                </div>
            </React.Fragment>
        : 
        <div>
            <RotateLoader 
                css={override}
                sizeUnit={"px"}
                size={15}
                color={'#c70139'}
                loading={loading}
            />
        </div>
    );
  }
  
  export default Resume;
  